
import Vuex from 'vuex'
import Vue from "vue";
const axios = require('axios');
import router from "./router/index.js";
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    connected: false,
    isLock: false,
    apiUrl: process.env.VUE_APP_API_URL,
    userRole: -1,
    loaded: false
  },
  mutations: {
    data(state) {
      return {
        state,
      }
    },
    created: function (state) {
      try {
        if (localStorage.pass && localStorage.login && localStorage.id && localStorage.teamId && localStorage.role) {
          axios.get(state.apiUrl + 'user/login', {
            params: {
              login: localStorage.login,
              password: localStorage.pass
            }
          })
            .then(response => {
              if (response.status == 200) { // HTTP.OK
                state.userRole = Number(localStorage.role);
                localStorage.login = response.data.login;
                localStorage.id = response.data.id;
                localStorage.pass = response.data.password;
                localStorage.teamId = response.data.teamId;
                localStorage.name = response.data.name;
                localStorage.email = response.data.email;
                localStorage.role = response.data.role;
                store.commit('setConnected', true);
                store.commit('setRole', response.data.role);
                state.loaded = true;
                state.connected = true;
                router.push({ name: 'Home' });
              } else {
                localStorage.removeItem("login");
                localStorage.removeItem("id");
                localStorage.removeItem("pass");
                localStorage.removeItem("teamId");
                localStorage.removeItem("name");
                localStorage.removeItem("email");
                localStorage.removeItem("role");
                state.loaded = true;
              }
            })
            .catch((e) => {
              console.log(e);
              state.loaded = true;
              router.push({ name: 'Connection' });
            })
        } else {
          state.loaded = true;
        }
      } catch (error) {
        state.loaded = true;
        router.push({ name: 'Connection' });
      }
    },
    setIsLock(state, value) {
      state.isLock = value;
    },
    setRole(state, value) {
      if (value) {
        state.userRole = value;
      }
    },
    setConnected(state, newValue) {
      if (this.debug) {
        console.log('setMessageAction triggered with', newValue)
      }
      state.connected = newValue;
    },
    clearConnected(state) {
      if (this.debug) {
        console.log('clearMessageAction triggered')
      }
      state.connected = false;
      localStorage.clear();
    },
  }
})
export default store;